<template>
    <div>
        <form v-if="!success" id="MarketingMaterialsOrderForm" @submit.prevent="submit" class="event-form">
            <div class="int-padding pt-0">
                <p>Pending item availability, orders will be fulfilled and shipped out within 10 business days of order. </p>
                <h3>Contact Information</h3>
                <div class="row clearfix">
                    <div class="col-lg-6 pr-4">
                        <div class="row">
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="first-name">First Name:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.first_name}" id="first-name" v-model="form.first_name"/>
                                    <ValidationError v-if="validationErrors.first_name">{{ validationErrors.first_name }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="last-name">Last Name:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.last_name}" id="last-name" v-model="form.last_name"/>
                                    <ValidationError v-if="validationErrors.last_name">{{ validationErrors.last_name }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="phone">Phone:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.phone}" id="phone" v-model="form.phone"/>
                                    <ValidationError v-if="validationErrors.phone">{{ validationErrors.phone }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="email">Email:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.email}" id="email" type="email" v-model="form.email"/>
                                    <ValidationError v-if="validationErrors.email">{{ validationErrors.email }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="message">Message:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormTextarea :class="{'is-invalid': validationErrors.message}" rows="10" id="message" v-model="form.message"/>
                                    <ValidationError v-if="validationErrors.message">{{ validationErrors.message }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="employee-type" class="d-block">Employee Type</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <div class="form-check">
                                        <FormRadio id="et-branch-sales-office-ea-ga" :value="1" v-model.number="form.employee_type"/>
                                        <FormLabel class="form-check-label" for="et-branch-sales-office-ea-ga">
                                            Branch/Sales Office/EA/GA
                                        </FormLabel>
                                    </div>
                                    <div class="form-check">
                                        <FormRadio id="et-aaa-call-center" :value="2" v-model.number="form.employee_type"/>
                                        <FormLabel class="form-check-label" for="et-aaa-call-center">
                                            AAA Call Center
                                        </FormLabel>
                                    </div>
                                    <div class="form-check">
                                        <FormRadio id="et-outside-membership-representative" :value="3" v-model.number="form.employee_type"/>
                                        <FormLabel class="form-check-label" for="et-outside-membership-representative">
                                            Outside Membership Representative
                                        </FormLabel>
                                    </div>
                                    <div class="form-check">
                                        <FormRadio id="et-independent-agent" :value="4" v-model.number="form.employee_type"/>
                                        <FormLabel class="form-check-label" for="et-independent-agent">
                                            Independent Agent
                                        </FormLabel>
                                    </div>
                                    <ValidationError v-if="validationErrors.employee_type">{{ validationErrors.employee_type }}</ValidationError>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 pl-4">
                        <div class="row">
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-id">Location ID:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_id}" id="location-id" v-model="form.location_id"/>
                                    <ValidationError v-if="validationErrors.location_id">{{ validationErrors.location_id }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-address">Location Address:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_address}" id="location-address" v-model="form.location_address"/>
                                    <ValidationError v-if="validationErrors.location_address">{{ validationErrors.location_address }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-city">Location City:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_city}" id="location-city" v-model="form.location_city"/>
                                    <ValidationError v-if="validationErrors.location_city">{{ validationErrors.location_city }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-state">Location State:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormSelect :class="{'is-invalid': validationErrors.location_state}" id="location-state" v-model="form.location_state">
                                        <option :value="state" v-for="state in states">{{ state }}</option>
                                    </FormSelect>
                                    <ValidationError v-if="validationErrors.location_state">{{ validationErrors.location_state }}</ValidationError>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="col-lg-4">
                                    <FormLabel :required="true" for="location-zip">Location Zip:</FormLabel>
                                </div>
                                <div class="col-lg-8">
                                    <FormInput :class="{'is-invalid': validationErrors.location_zip}" id="location-zip" v-model="form.location_zip"/>
                                    <ValidationError v-if="validationErrors.location_zip">{{ validationErrors.location_zip }}</ValidationError>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-divider mt-0 mb-0"></div>

            <div v-if="products" class="container-fluid">
                <div class="int-padding">
                    <h3>AAA Marketing Materials Order Form</h3>
                    <div class="row clearfix">
                        <div class="col-lg-6 pr-4">
                            <div class="row">
                                <template v-for="product in nonPremiumPremiumProducts">
                                    <div class="input-group">
                                        <div class="col-lg-6">
                                            <FormLabel :for="product.slug">
                                                <template v-if="product.pack_quantity">
                                                    {{ product.name }} ({{ product.pack_quantity }}/pack):
                                                </template>
                                                <template v-else>
                                                    {{ product.name }}:
                                                </template>
                                                <template v-if="product.subtitle">
                                                    <div v-html="product.subtitle"></div>
                                                </template>
                                            </FormLabel>
                                        </div>
                                        <div class="col-lg-6">
                                            <FormInput type="number" min="0" :class="{'is-invalid': validationErrors[`products.${product.slug}`]}" :id="product.slug" v-model="form.products[product.slug]"/>
                                            <ValidationError v-if="validationErrors[`products.${product.slug}`]">{{ validationErrors[`products.${product.slug}`] }}</ValidationError>
                                        </div>
                                    </div>
                                </template>
                                <div class="col-12 my-3">
                                    <h4>PREMIUM ITEMS:</h4>
                                </div>
                                <template v-for="product in premiumPremiumProducts">
                                    <div class="input-group">
                                        <div class="col-lg-6">
                                            <FormLabel :for="product.slug">
                                                <template v-if="product.pack_quantity">
                                                    {{ product.name }} ({{ product.pack_quantity }}/pack):
                                                </template>
                                                <template v-else>
                                                    {{ product.name }}:
                                                </template>
                                                <template v-if="product.subtitle">
                                                    <div v-html="product.subtitle"></div>
                                                </template>
                                            </FormLabel>
                                        </div>
                                        <div class="col-lg-6">
                                            <FormInput type="number" min="0" :class="{'is-invalid': validationErrors[`products.${product.slug}`]}" :id="product.slug" v-model="form.products[product.slug]"/>
                                            <ValidationError v-if="validationErrors[`products.${product.slug}`]">{{ validationErrors[`products.${product.slug}`] }}</ValidationError>
                                        </div>
                                    </div>
                                </template>
                                <div class="input-group">
                                    <div class="col-lg-12 mt-4">
                                        <FormButton :pending="pending" pendingText="Submitting">Submit Request</FormButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="errorMessage" class="mt-3 alert alert-danger">
                <p class="mb-0">{{ errorMessage }}</p>
            </div>
        </form>
        <PremiumMaterialsOrderConfirmation v-else :order="order" :employeeTypes="employeeTypes"/>
    </div>
</template>

<script>
import FormLabel from '@/components/form/FormLabel';
import FormInput from '@/components/form/FormInput';
import ValidationError from '@/components/form/ValidationError';
import FormMixin from '@/mixins/FormMixin';
import FormSelect from '@/components/form/FormSelect';
import { states } from '@/states';
import MarketingService from '@/services/marketing.service';
import FormButton from '@/components/form/FormButton';
import FormRadio from '@/components/form/FormRadio.vue';
import FormTextarea from '@/components/form/FormTextarea.vue';
import PremiumMaterialsOrderConfirmation from '@/components/marketing/PremiumMaterialsOrderConfirmation.vue';

const DEFAULT = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    location_id: '',
    location_address: '',
    location_city: '',
    location_state: '',
    location_zip: '',
    message: '',
    employee_type: '',
    products: {}
};

const EMPLOYEE = {
    first_name: '',
    last_name: '',
    email: '',
    location_code: '',
};

export default {
    components: {
        PremiumMaterialsOrderConfirmation,
        FormTextarea,
        FormButton,
        FormLabel,
        FormRadio,
        FormSelect,
        FormInput,
        ValidationError
    },
    mixins: [
        FormMixin
    ],
    props: {
        employeeTypes: {
          type: Object,
          default() {
              return {};
          }
        },
        employee: {
            type: Object,
            default() {
                return EMPLOYEE;
            }
        },
        products: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            states: states,
            form: {...DEFAULT, ...{
                first_name: this.employee.first_name,
                last_name: this.employee.last_name,
                email: this.employee.email,
                location_id: this.employee.location_code,
             }},
            order: {}
        }
    },
    computed: {
        nonPremiumPremiumProducts() {
            return this.products.filter(product => !product.premium_premium);
        },
        premiumPremiumProducts() {
            return this.products.filter(product => Boolean(product.premium_premium) === true);
        }
    },
    created() {
      this.products.forEach(product => {
         this.form.products[product.slug] = 0;
      });
    },
    methods: {
        async submit() {
            this.pending = true;
            this.errorMessage = '';
            this.errorStatusCode = null;
            this.validationErrors = {};

            try {
                this.order = await MarketingService.orderPremium(this.form);
                this.success = true;
            } catch (error) {
                this.handleError(error);
            } finally {
                this.pending = false;
            }
        }
    }
}
</script>
